<template>
  <el-dialog width="1140px"  top="70px" :modal="false" :close-on-click-modal="false" :visible.sync="dialogVisible">
    <div id="pie-dom"></div>
    <div id="chart-dom"></div>
    <span slot="footer" class="dialog-footer">
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="dialogVisible = false">关 闭</div>
    </span>
  </el-dialog>
</template>
<script>
const echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/pie')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/grid')
require('echarts/lib/component/toolbox')
require('echarts/lib/component/legend')

function getXAxis() {
  const legend = []
  const date = new Date()
  const thisYear = date.getFullYear()
  const thisMonth = date.getMonth() + 1
  for (let year = 1998; year < thisYear; year++) {
    for (let i = 1; i < 5; i++) {
      legend.push(`${year}Q${i}`)
    }
  }
  for (let quarter = 1; quarter < 4; quarter++) {
    if (thisMonth > (quarter - 1) * 3) legend.push(`${thisYear}Q${quarter}`)
  }
  return legend
}
function getOption(arr) {
  const xAxis = getXAxis()
  const type = ['混合型', '股票型', '货币市场型', '债券型', 'QDII', '保本型', 'FOF'].reverse()
  const res = []
  let first = -1
  type.forEach(v => {
    const fund = arr.filter(val => val.fundNature === v)
    const dataArr = []
    let ind = 0
    xAxis.forEach((val, index) => {
      const date = fund[ind] && fund[ind].date
      if (val === date) {
        first = first < 0 || first > index ? index : first
        dataArr.push(fund[ind].value)
        ind++
      } else dataArr.push(0)
    })
    res.push({
      name: v,
      type: 'bar',
      stack: '基金',
      barWidth: 5,
      data: dataArr,
    })
  })

  if (first > 0) {
    xAxis.splice(0, first)
    res.forEach(val => val.data.splice(0, first))
  }
  return { series: res, xAxis: xAxis }
}

export default {
  data: function() {
    return {
      dialogVisible: false,
      myChart: {},
    }
  },
  methods: {
    async open(company) {
      this.getCompanyFund(company)
      this.getCompanyFundType(company)
    },
    async getCompanyFundType(company) {
      const res = await app.service('company').getCompanyFundType({ 简称: company.简称 })
      if (res.status !== 'success') return this.$message(res.msg)
      this.dialogVisible = true
      const legendData = res.data.map(val => val.key)
      const optionData = res.data.map(val => ({ value: val.value, name: val.key }))
      const option = {
        title: {
          text: '产品类型分布',
          x: 'center',
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} <br/> 占比：{d}%',
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: legendData,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
          right: '5%',
        },
        series: [
          {
            type: 'pie',
            radius: '50%',
            center: ['50%', '60%'],
            selectedMode: 'single',
            data: optionData,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }
      this.$nextTick(_ => {
        const myChart = echarts.init(this.$el.querySelector('#pie-dom'))
        myChart.setOption(option)
      })
    },

    async getCompanyFund(company) {
      const res = await app.service('company').getCompanyFund({ 公司名称: company.公司名称, 简称: company.简称 })
      if (res.status !== 'success') return this.$message(res.msg)
      this.dialogVisible = true
      const { series, xAxis } = getOption(res.data.scale)
      const option = {
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        color: ['#f45b5b', '#2b908f', '#e4d354', '#f15c80', '#7f85e9', '#f7a25c', '#8fed7d', '#7cb5ec'],
        legend: {
          data: ['混合型', '股票型', '货币市场型', '债券型', 'QDII', '保本型', 'FOF'],
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: xAxis,
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series: series,
        toolbox: {
          feature: {
            saveAsImage: {},
          },
          right: '5%',
        },
      }
      this.$nextTick(_ => {
        const myChart = echarts.init(this.$el.querySelector('#chart-dom'))
        myChart.setOption(option)
      })
    },
  },
}
</script>
<style scoped>
#chart-dom {
  width: 1000px;
  height: 360px;
}
#pie-dom {
  width: 555px;
  height: 300px;
  margin: 0 auto;
}
</style>

